module.exports = __webpack_public_path__ + "img/p-logo.774172f0.svg";